import { render, staticRenderFns } from "./MonthlySavingInsight.vue?vue&type=template&id=1a4f79ec&scoped=true"
import script from "./MonthlySavingInsight.vue?vue&type=script&lang=js"
export * from "./MonthlySavingInsight.vue?vue&type=script&lang=js"
import style0 from "./MonthlySavingInsight.vue?vue&type=style&index=0&id=1a4f79ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f79ec",
  null
  
)

export default component.exports